import { render, staticRenderFns } from "./ProvidersCard.vue?vue&type=template&id=caecc41e&"
import script from "./ProvidersCard.vue?vue&type=script&lang=js&"
export * from "./ProvidersCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports